import * as filestack from "filestack-js";
import { SharedFile } from "../../types/file";

export function getFileCdnUrl(filestack: filestack.Client, file: SharedFile): string {
  const baseUrl = filestack.utils.resolveCdnUrl(filestack.session, file.handle);
  return `${baseUrl}/${file.handle}?policy=${file.security.policy}&signature=${file.security.signature}`;
}
